import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Box, FileText, Inbox, Mail } from "lucide-react";

const Stat = ({ icon: Icon, label, value, accent = "orange" }) => (
  <div className="bg-white border border-zinc-200 rounded-md p-6">
    <div className="flex items-start justify-between">
      <div>
        <div className="text-xs uppercase tracking-widest font-bold text-zinc-500">{label}</div>
        <div className="font-display font-black text-4xl mt-2 text-zinc-950">{value}</div>
      </div>
      <div className={`w-10 h-10 rounded-md flex items-center justify-center ${accent === "green" ? "bg-green-50 text-green-600" : "bg-orange-50 text-orange-600"}`}><Icon size={20} /></div>
    </div>
  </div>
);

const Dashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl font-black tracking-tight text-zinc-950">Dashboard</h1>
      <p className="text-sm text-zinc-500 mt-1">Overview of your content & inbox.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        <Stat icon={Box} label="Products" value={data?.products_count ?? "—"} />
        <Stat icon={FileText} label="Blog posts" value={data?.blog_count ?? "—"} accent="green" />
        <Stat icon={Inbox} label="Total contacts" value={data?.contacts_count ?? "—"} />
        <Stat icon={Mail} label="Unread" value={data?.unread_contacts ?? "—"} accent="green" />
      </div>

      <div className="mt-10 bg-white border border-zinc-200 rounded-md">
        <div className="px-6 py-4 border-b border-zinc-200">
          <div className="font-display font-bold text-zinc-900">Recent contact submissions</div>
        </div>
        <div className="divide-y divide-zinc-100">
          {(data?.recent_contacts || []).length === 0 ? (
            <div className="px-6 py-10 text-sm text-zinc-500 text-center">No submissions yet.</div>
          ) : (
            data.recent_contacts.map((c) => (
              <div key={c.id} className="px-6 py-4 flex items-start justify-between gap-4">
                <div>
                  <div className="font-semibold text-zinc-900">{c.name} <span className="text-zinc-400 font-normal">· {c.email}</span></div>
                  <div className="text-sm text-zinc-600 mt-1">{c.subject || c.message?.slice(0, 90)}</div>
                </div>
                <div className="text-xs text-zinc-500 whitespace-nowrap">{new Date(c.created_at).toLocaleDateString()}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
